module.exports = __webpack_public_path__ + "media/images/checkout/visa-32074ea7a08dcbb6e3341d697729ef11.png";